import { DEFAULT_FORMAT_FALLBACK } from './constants';
import { FormatNumberOptions } from './types';

export const resolveNumberValue = (value: number | string | null | undefined): number | null => {
  if (value === null || value === undefined) return null;

  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  const normalizedValue = value.trim().replace(/\s/g, '').replace(',', '.');

  if (!normalizedValue) return null;

  const parsedValue = Number(normalizedValue);

  return Number.isFinite(parsedValue) ? parsedValue : null;
};

export const formatNumber = (options: FormatNumberOptions): string => {
  const {
    fallback = DEFAULT_FORMAT_FALLBACK,
    maximumFractionDigits = 20,
    minimumFractionDigits,
    useGrouping = true,
    value
  } = options;

  const numberValue = resolveNumberValue(value);

  if (numberValue === null) return fallback;

  return new Intl.NumberFormat('ru-RU', {
    maximumFractionDigits,
    minimumFractionDigits,
    useGrouping
  }).format(numberValue).replace(/\u202f/g, '\u00A0');
};